import { globalAlertType } from '@/constants/global';
import { vuexEventPathGenerator } from '@/utils';
export const actionType = {
    confirm: 'confirm',
    alert: 'alert',
    close: 'close',
};
export const alertActionType = vuexEventPathGenerator(actionType, 'alert');
const action = {
    /**
     * 버튼 두개 (확인, 취소)
     */
    async [actionType.confirm]({ commit }, payload) {
        return new Promise((resolve) => {
            commit('OPEN_ALERT', {
                alertType: globalAlertType.CONFIRM,
                selectedItem: '',
                resolve,
                ...payload,
            });
        });
    },
    /**
     * 버튼 한개 (확인)
     */
    [actionType.alert]({ commit }, payload) {
        commit('OPEN_ALERT', {
            alertType: globalAlertType.ALERT,
            selectedItem: '',
            ...payload,
        });
    },
    /**
     * 취소
     */
    [actionType.close]({ commit }) {
        commit('CLOSE_ALERT');
    },
};
export default action;
